import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import Assignment from '@mui/icons-material/Assignment';
import { Card, IconButton } from '@totalsoft/rocket-ui';
import { copyToClipboard } from 'utils/functions';
import { LogId, LogPropertyContainer, LogGrid } from 'features/logs/components/LogStyles';
import ErrorIcon from '@mui/icons-material/Error';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import InfoIcon from '@mui/icons-material/Info';

const SystemLogComponent = ({ data }) => {
  const { t } = useTranslation();

  const icon = {
    error: <ErrorIcon color='error' />,
    warning: <WarningRoundedIcon color='warning' />,
    fatal: <ErrorIcon color='error' />,
    info: <InfoIcon />
  };

  const IconDisplay = ({ level }) => {
    return icon[level] || icon[icon.info];
  };

  return (
    <Card disablePadding>
      <LogGrid container py={1} px={3} id={`systemLogItem_${data.id}`} logLevel={data.level.toLowerCase()}>
        <Grid container item xs={1}>
          <IconDisplay level={data.level.toLowerCase()} />
        </Grid>
        <LogPropertyContainer item xs={4} lg={2}>
          <strong>{t('Logs.ErrorId')}:</strong>
          <LogId to={`/logs/systemLogs/logDetail/${data.id}`}>{data.id}</LogId>
        </LogPropertyContainer>

        <LogPropertyContainer item xs={8} lg={4}>
          <span title={data.correlationId}>
            <strong>{t('Logs.CorrelationId')}:</strong>
            {data.correlationId}
          </span>
        </LogPropertyContainer>

        <LogPropertyContainer item xs={11} lg={5}>
          <span title={data.message}>
            <strong>{t('Logs.Message')}:</strong>
            {data.message}
          </span>
        </LogPropertyContainer>
        <LogPropertyContainer item xs={1} />

        <LogPropertyContainer item xs={5}>
          <span title={data.level}>
            <strong>{t('Logs.Level')}:</strong>
            {data.level}
          </span>
        </LogPropertyContainer>

        <Grid item container xs={6} justifyContent='end'>
          <IconButton
            id={`Logs_CopyBtn_${data.id}`}
            size='small'
            variant='text'
            color='primary'
            tooltip={t('General.CopyToClipboard')}
            onClick={copyToClipboard(data.message)}
          >
            <Assignment fontSize={'inherit'} />
          </IconButton>
        </Grid>
      </LogGrid>
    </Card>
  );
};

SystemLogComponent.propTypes = {
  data: PropTypes.object.isRequired
};

export default SystemLogComponent;
